import React, { Suspense, lazy } from "react";
import { Switch, Route } from "react-router-dom";
import HeaderAppBar from "./components/HeaderAppBar";
import Layout from "./Layout";
import store from "./redux/store";
import { Provider, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import MiniDrawer from "./components/MiniDrawer";
import Loading from "./common/Loading";
import RootDashboardView from "./views/RootDashboardView";
import {
  INTELLIGENT_REPORT_PATH,
  IntelligentReportProvider,
} from "./components/IAReports/IntelligentReportContext";
// import { messaging } from './services/firebase';
// import firebase from './services/firebase';
// import app from './services';

const LoginView = lazy(() => import("./views/LoginView"));
const RegisterView = lazy(() => import("./views/RegisterView"));
const NoMatch = lazy(() => import("./views/NoMatch"));

const VideoCallView = lazy(() => import("./views/VideoCallView"));
const ConfigView = lazy(() => import("./views/ConfigView"));
const Directory = lazy(() => import("./views/Directory"));
const RegistersView = lazy(() => import("./views/RegistersView"));

const DevicesView = lazy(() => import("./views/DevicesView"));
const HumanResourses = lazy(() => import("./views/HumanResourses"));
const Companies = lazy(() => import("./views/Companies"));
const LinksDevices = lazy(() => import("./views/LinksDevices"));
const Locations = lazy(() => import("./views/Locations"));
const IndustrialAssets = lazy(() => import("./views/IndustrialAssets"));
const Devices = lazy(() => import("./views/Devices"));
const Sections = lazy(() => import("./views/Sections"));
const Catalogs = lazy(() => import("./views/Catalogs"));
const WorkGroups = lazy(() => import("./views/WorkGroups"));
const Calendar = lazy(() => import("./views/Calendar"));
const ViewerView = lazy(() => import("./views/ViewerView"));
const HomeView = lazy(() => import("./views/HomeView"));
const DashboardView = lazy(() => import("./views/DashboardView"));
const IntelligentReportView = lazy(() => import("./views/IntelligentReportView"));

console.log('[versions][client]', {
  socketioClient: require('socket.io-client/package.json').version,
});

function ModuleRoutes() {
  const loginRevision = useSelector(
    (state) => state.session.loginRevision || 0,
  );

  return (
    <Switch key={`login-${loginRevision}`}>
      {[
        { path: "/", exact: true, component: <RootDashboardView /> },
        { path: "/home", component: <HomeView /> },
        { path: "/cemedi", component: <DashboardView /> },
        { path: "/work-groups", component: <WorkGroups /> },
        { path: "/calendar", component: <Calendar /> },
        { path: "/users", component: <HumanResourses /> },
        { path: "/companies", component: <Companies /> },
        { path: "/links", component: <LinksDevices /> },
        { path: "/locations", component: <Locations /> },
        { path: "/sections", component: <Sections /> },
        { path: "/industrial-assets", component: <IndustrialAssets /> },
        { path: "/devices", component: <Devices /> },
        { path: "/login", component: <LoginView /> },
        { path: "/video-call", component: <VideoCallView /> },
        { path: "/viewer", component: <ViewerView /> },
        { path: "/config", component: <ConfigView /> },
        { path: "/catalogs", component: <Catalogs /> },
        { path: "/registers", component: <RegistersView /> },
        { path: "*", component: <NoMatch /> },
      ].map(({ path, exact = false, component }, index) => (
        <Route key={index} path={path} exact={exact}>
          <Suspense
            fallback={
              <div style={{}}>
                <Loading />
              </div>
            }
          >
            {component}
          </Suspense>
        </Route>
      ))}
    </Switch>
  );
}

function App() {
  let persistor = persistStore(store);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <IntelligentReportProvider>
          <Switch>
            <Route exact path={INTELLIGENT_REPORT_PATH}>
              <Layout>
                <Suspense fallback={<Loading />}>
                  <IntelligentReportView />
                </Suspense>
              </Layout>
            </Route>
            <Route path="*">
              <Layout>
                <MiniDrawer>
                  <ModuleRoutes />
            {/* <Switch>
              <Route key={"/"} exact={true} path="/">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <DashboardView />
                </Suspense>
              </Route>
              <Route key={"/home"} path="/home">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <HomeView />
                </Suspense>
              </Route>
              <Route key={"/work-groups"} path="/work-groups">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <WorkGroups />
                </Suspense>
              </Route>
              <Route key={"/calendar"} path="/calendar">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <Calendar />
                </Suspense>
              </Route>
              <Route key={"/users"} path="/users">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <HumanResourses />
                </Suspense>
              </Route>
              <Route key={"/companies"} path="/companies">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <Companies />
                </Suspense>
              </Route>
              <Route key={"/links"} path="/links">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <LinksDevices />
                </Suspense>
              </Route>
              <Route key={"/locations"} path="/locations">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <Locations />
                </Suspense>
              </Route>
              <Route key={"/sections"} path="/sections">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <Sections />
                </Suspense>
              </Route>
              <Route key={"/industrial-assets"} path="/industrial-assets">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <IndustrialAssets />
                </Suspense>
              </Route>
              <Route key={"/devices"} path="/devices">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <Devices />
                </Suspense>
              </Route>
              <Route key={"/login"} path="/login">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <LoginView />
                </Suspense>
              </Route>
              <Route key={"/video-call"} path="/video-call">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <VideoCallView />
                </Suspense>
              </Route>
              <Route key={"/viewer"} path="/viewer">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <ViewerView />
                </Suspense>
              </Route>

              <Route key={"/config"} path="/config">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <ConfigView />
                </Suspense>
              </Route>
              <Route key={"/catalogs"} path="/catalogs">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <Catalogs />
                </Suspense>
              </Route>
              <Route key={"/registers"} path="/registers">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <RegistersView />
                </Suspense>
              </Route>

              <Route key={"*"} path="*">
                <Suspense
                  fallback={
                    <div style={{}}>
                      <Loading />
                    </div>
                  }
                >
                  <NoMatch />
                </Suspense>
              </Route>
            </Switch> */}
                </MiniDrawer>
              </Layout>
            </Route>
          </Switch>
        </IntelligentReportProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
